"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        listStyle: 'none',
        paddingLeft: 0
    }
};
//# sourceMappingURL=menu.style.js.map